import { useCallback, useEffect, useRef, useState } from 'react';

import use123zapStore from '../../../../../context/123zapStore';
import { GetModeGraphicData } from '../../../../../services/api/Dashboard/GetModeGraphicData';

function formatDate(date) {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

function getPeriodDates(period) {
  const today = new Date();
  let startDate;
  let endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  if (period === 'current_month') {
    startDate = new Date(today.getFullYear(), today.getMonth(), 1);
    endDate = today;
  } else if (period === 'last_30_days') {
    startDate = new Date(today);
    startDate.setDate(today.getDate() - 29);
    endDate = today;
  } else {
    const monthsByPeriod = {
      last_3_months: 3,
      last_6_months: 6,
      last_12_months: 12,
    };
    const months = monthsByPeriod[period] || monthsByPeriod.last_6_months;
    startDate = new Date(today.getFullYear(), today.getMonth() - (months - 1), 1);
  }

  return {
    start_date: formatDate(startDate),
    end_date: formatDate(endDate),
  };
}

export default function useModeGraphicController() {
  const setTableColumns = use123zapStore((state) => state.setTableColumns);
  const setCampaignsSummaryData = use123zapStore((state) => state.setCampaignsSummaryData);
  const setExcelTableColumns = use123zapStore((state) => state.setExcelTableColumns);
  const setExcelTableRows = use123zapStore((state) => state.setExcelTableRows);
  const setShowNewTable = use123zapStore((state) => state.setShowNewTable);
  const setShowReceived = use123zapStore((state) => state.setShowReceived);
  const setReceivedMessages = use123zapStore((state) => state.setReceivedMessages);
  const modalData = use123zapStore((state) => state.modalData);
  const setModalData = use123zapStore((state) => state.setModalData);

  const [dataGraphic, setDataGraphic] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingTable, setLoadingTable] = useState(false);
  const [periodFilter, setPeriodFilter] = useState('last_6_months');

  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null);
  const lastClickedDateRef = useRef(null);

  const resetModal = useCallback(() => {
    setShowNewTable(false);
    setExcelTableColumns([]);
    setExcelTableRows([]);
    setTableColumns([]);
    setCampaignsSummaryData([]);
    setShowReceived(false);
    setReceivedMessages({ columns: [], rows: [] });
  }, [
    setCampaignsSummaryData,
    setExcelTableColumns,
    setExcelTableRows,
    setReceivedMessages,
    setShowNewTable,
    setShowReceived,
    setTableColumns,
  ]);

  useEffect(() => {
    const { start_date, end_date } = getPeriodDates(periodFilter);
    setLoading(true);
    resetModal();
    lastClickedDateRef.current = null;

    GetModeGraphicData(start_date, end_date)
      .then((response) => {
        setDataGraphic(response.data);
      })
      .catch((error) => {
        console.error('Erro ao buscar os dados:', error);
      })
      .finally(() => setLoading(false));
  }, [periodFilter, resetModal]);

  return {
    dataGraphic,
    openModal,
    setOpenModal,
    loading,
    periodFilter,
    setPeriodFilter,
    loadingTable,
    setLoadingTable,
    chartRef,
    chartInstanceRef,
    lastClickedDateRef,
    modalData,
    setModalData,
    resetModal,
  };
}
